import styled from 'styled-components';

export const ResetStyle = styled.div`
  .ant-picker {
    padding: 4px 11px 4px !important;
  }

  .bw_frm_box input {
    padding: 4px 11px !important;
  }
`;

export const DiscountProgramShell = styled.div`
  --dp-ink: #182230;
  --dp-muted: #667085;
  --dp-border: #e4e7ec;
  color: var(--dp-ink);
  max-width: 1480px;
  margin: 0 auto;
  padding-bottom: 16px;
  .dp-header { background: #fff; border: 1px solid var(--dp-border); border-radius: 14px; overflow: hidden; }
  .dp-header-top { display: flex; justify-content: space-between; align-items: center; padding: 18px 24px 0; }
  .dp-back { background: none; border: 0; padding: 0; color: var(--dp-muted); font-size: 12px; display: flex; align-items: center; gap: 8px; cursor: pointer; }
  .dp-back:hover { color: var(--portal-color-primary); }
  .dp-context { font-size: 10px; font-weight: 700; letter-spacing: 1.6px; color: #98a2b3; }
  .dp-heading-row { display: flex; justify-content: space-between; gap: 24px; padding: 22px 24px 24px; }
  .dp-heading-copy { min-width: 0; }
  .dp-heading-copy h1 { font-size: 23px; line-height: 1.4; letter-spacing: -.4px; margin: 12px 0 8px; color: var(--dp-ink); font-weight: 700; }
  .dp-heading-copy p { margin: 0; font-size: 13px; line-height: 1.6; color: var(--dp-muted); }
  .dp-header-actions { display: flex; align-items: flex-start; flex-shrink: 0; gap: 8px; padding-top: 36px; }
  .dp-badges { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
  .dp-type { font-size: 11px; font-weight: 600; color: #344054; padding-right: 8px; border-right: 1px solid var(--dp-border); }
  .dp-badge { font-size: 10px; font-weight: 600; border-radius: 5px; padding: 4px 8px; background: #f2f4f7; color: #475467; }
  .dp-badge-warning { color: #854a0e; background: #fff4dc; }
  .dp-badge-success { color: #146544; background: #edf7f0; }
  .dp-summary { display: grid; grid-template-columns: 1.15fr .8fr 1.5fr .65fr; background: #fbfcfd; border-top: 1px solid var(--dp-border); padding: 18px 24px; }
  .dp-summary > div { padding: 0 20px; border-left: 1px solid var(--dp-border); }
  .dp-summary > div:first-child { border-left: none; padding-left: 0; }
  .dp-summary > div > span { display: block; color: var(--dp-muted); font-size: 10px; font-weight: 600; letter-spacing: .6px; margin-bottom: 7px; }
  .dp-summary strong { display: block; font-size: 13px; line-height: 1.5; }
  .dp-summary .dp-rate { font-size: 24px; line-height: 1; letter-spacing: -.5px; }
  .dp-date-arrow { padding: 0 4px; color: #98a2b3; }
  .dp-workspace { display: grid; grid-template-columns: 250px minmax(0, 1fr); align-items: start; gap: 24px; margin-top: 24px; }
  .dp-aside { position: sticky; top: 86px; display: grid; gap: 16px; }
  .dp-nav { padding: 18px 12px 12px; border: 1px solid var(--dp-border); border-radius: 12px; background: white; }
  .dp-side-title { font-size: 10px; font-weight: 700; letter-spacing: 1px; color: #98a2b3; margin: 0 10px 12px; }
  .dp-nav a { display: flex; gap: 10px; align-items: center; padding: 12px 10px; font-size: 12px; font-weight: 500; line-height: 1.5; color: #475467; border-radius: 7px; }
  .dp-nav a:hover, .dp-nav a:focus-visible { background: #fff2f2; color: #b42318; }
  .dp-nav-number { color: #98a2b3; font-size: 10px; font-variant-numeric: tabular-nums; }
  .dp-warning { background: #fffbf1; border: 1px solid #f2deb3; border-radius: 12px; padding: 17px; }
  .dp-warning h2 { font-size: 13px; display: flex; gap: 8px; align-items: center; color: #854a0e; margin: 0 0 12px; }
  .dp-warning ul { padding-left: 17px; margin: 0; }
  .dp-warning li { color: #7a5b32; font-size: 11px; line-height: 1.75; padding-left: 1px; margin-top: 9px; }
  .dp-side-note { display: flex; align-items: flex-start; gap: 9px; padding: 0 8px; color: #667085; }
  .dp-side-note > span { margin-top: 4px; }
  .dp-side-note p { margin: 0; font-size: 11px; line-height: 1.7; }
  .dp-main { min-width: 0; }
  .dp-section { margin-bottom: 24px; scroll-margin-top: 90px; }
  .dp-section-heading { display: flex; align-items: center; gap: 11px; margin: 0 0 13px; }
  .dp-section-heading > span { display: flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid var(--dp-border); border-radius: 8px; background: #fff; color: #667085; font-size: 11px; }
  .dp-section-heading h2 { font-size: 15px; line-height: 1.5; font-weight: 650; margin: 0; color: var(--dp-ink); }
  .dp-section-heading p { font-size: 11px; color: var(--dp-muted); margin: 3px 0 0; }
  .dp-section-content { display: grid; gap: 12px; }
  .dp-scope-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; align-items: start; }
  &&& .bw_items_frm { background: #fff; border: 1px solid var(--dp-border); border-radius: 12px; box-shadow: 0 1px 2px rgba(16,24,40,.025); margin: 0; padding: 0; overflow: visible; }
  &&& .bw_items_frm > .bw_collapse { border: 0; border-radius: 12px !important; background: transparent; box-shadow: none; padding: 0; }
  &&& .bw_collapse_title { border-bottom: 1px solid #f0f2f5; border-radius: 12px 12px 0 0; background: white; padding: 15px 20px; min-height: 48px; }
  &&& .bw_collapse_title h3 { font-size: 13px; line-height: 1.5; color: #344054; font-weight: 600; margin: 0; }
  &&& .bw_collapse_icon { font-size: 14px; color: #98a2b3; }
  &&& .bw_collapse_panel { padding: 20px; }
  &&& .bw_frm_box { margin-bottom: 14px; }
  &&& .dp-information-form { display: grid; grid-template-columns: repeat(4,minmax(0,1fr)); gap: 18px 16px; margin: 0; }
  &&& .dp-information-form > .bw_frm_box { width: 100%; max-width: 100%; min-width: 0; min-height: 0; margin: 0; padding: 0; }
  &&& .dp-information-form > .bw_col_6 { grid-column: span 2; }
  &&& .dp-information-form > .bw_col_12 { grid-column: 1 / -1; }
  &&& .ant-picker-range { display: inline-flex !important; align-items: center; }
  &&& .ant-picker-range .ant-picker-input { flex: 1; width: auto; min-width: 0; }
  &&& .ant-picker-range .ant-picker-range-separator, &&& .ant-picker-range .ant-picker-suffix { flex: none; width: auto; }

  &&& .bw_frm_box > label, &&& .bw_frm_box > p, .dp-target label { font-size: 12px; }
  .dp-target > p, .dp-preview p { font-size: 12px; line-height: 1.7; color: var(--dp-muted); }
  .dp-preview h4 { margin: 0 0 6px; font-size: 14px; font-weight: 650; }
  .dp-policy-grid { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 18px 24px; }
  .dp-policy-grid dt { color: var(--dp-muted); font-size: 11px; margin-bottom: 6px; }
  .dp-policy-grid dd { margin: 0; font-size: 13px; font-weight: 600; line-height: 1.6; }
  .dp-policy-note { color: var(--dp-muted); font-size: 12px; line-height: 1.7; margin: 16px 0 0; }
  &&& .bw_checkbox, &&& .bw_radio { line-height: 1.6; font-size: 12px; }
  &&& .bw_box_card { border-radius: 8px !important; box-shadow: none; }
  &&& .bw_table { border-collapse: separate; border-spacing: 0; min-width: 0; }
  &&& .bw_table th { background: #f8fafc; font-size: 11px; line-height: 1.6; color: #475467; font-weight: 600; padding: 12px; border-color: #e9edf2; }
  &&& .bw_table td { padding: 12px; font-size: 12px; border-color: #edf0f4; }
  &&& .ant-input-number, &&& .ant-select-selector, &&& .ant-picker { border-radius: 7px; }
  &&& .ant-btn-primary { background: var(--portal-color-primary, #cf252b); border-color: var(--portal-color-primary, #cf252b); }
  &&& .ant-btn-primary:hover { background: var(--portal-color-primary-hover, #b42318); border-color: var(--portal-color-primary-hover, #b42318); }
  &&& .ant-btn { border-radius: 7px; font-size: 12px; height: 36px; box-shadow: none; }
  &&& .ant-alert-info { background: #f7f9fc; border-color: #e4e9f0; }
  &&& .ant-alert-message { font-size: 12px; font-weight: 600; color: #344054; }
  &&& .ant-alert-description { font-size: 11px; color: #667085; line-height: 1.7; }
  .dp-footer { display: flex; justify-content: space-between; align-items: center; gap: 16px; padding: 16px 20px; border: 1px solid var(--dp-border); border-radius: 12px; background: white; }
  .dp-footer > span { color: #667085; font-size: 11px; }
  .dp-footer > div { display: flex; gap: 8px; }
  @media (max-width: 1100px) {
    .dp-workspace { grid-template-columns: 210px minmax(0,1fr); gap: 18px; }
    .dp-scope-grid { grid-template-columns: 1fr; }
    .dp-heading-row { flex-wrap: wrap; gap: 16px; }
    .dp-header-actions { padding-top: 0; }
    .dp-summary { grid-template-columns: repeat(2,minmax(0,1fr)); gap: 16px; }
    .dp-summary > div:nth-child(3) { border-left: none; padding-left: 0; }
  }
  @media (max-width: 760px) {
    .dp-workspace { display: flex; flex-direction: column; gap: 20px; }
    .dp-aside { position: static; width: 100%; }
    .dp-nav { display: none; }
    .dp-side-note { display: none; }
    .dp-main { width: 100%; }
    &&& .dp-information-form { grid-template-columns: 1fr; }
    &&& .dp-information-form > .bw_col_6 { grid-column: auto; }
    .dp-policy-grid { grid-template-columns: 1fr; }
    .dp-header-top { padding: 16px 16px 0; }
    .dp-heading-row { padding: 18px 16px; }
    .dp-heading-copy h1 { font-size: 19px; }
    .dp-summary { padding: 16px; }
    .dp-summary > div { padding: 0 10px; }
    .dp-summary strong { font-size: 11px; }
    .dp-header-actions { width: 100%; justify-content: flex-end; }
    &&& .bw_collapse_panel { padding: 14px; }
    &&& .bw_col_6, &&& .bw_col_3, &&& .bw_col_4, &&& .bw_col_5 { width: 100%; max-width: 100%; flex-basis: 100%; }
    .dp-footer { flex-wrap: wrap; }
    .dp-footer > div { width: 100%; justify-content: flex-end; }
  }
`;
